import React from "react";
import { useQuery } from "@tanstack/react-query";
import apiV2 from "api-v2";
import {
  SelectWithLabel,
  BaseSelectWithLabelProps,
  SelectOption,
} from "../InputWithLabel/SelectWithLabel";

interface RfqDocumentCategory {
  id: number;
  name: string;
}

interface RfqDocumentCategoriesResponse {
  data: RfqDocumentCategory[];
}

export const useRfqDocumentCategories = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["rfq-categories"],
    queryFn: async () => {
      const response = await apiV2.get<RfqDocumentCategoriesResponse>(
        `rfq/categories`
      );
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
  });

  const options: SelectOption[] = (data ?? []).map((cat) => ({
    value: cat.id,
    label: cat.name,
  }));

  return { options, isLoading };
};

interface RfqDocumentCategorySelectProps
  extends Omit<BaseSelectWithLabelProps, "options" | "isLoading"> {
  rfqId: number;
}

export const RfqDocumentCategorySelect = ({
  rfqId,
  label = "Category",
  placeholder = "Select category",
  ...rest
}: RfqDocumentCategorySelectProps) => {
  const { options, isLoading } = useRfqDocumentCategories();

  return (
    <SelectWithLabel
      options={options}
      isLoading={isLoading}
      label={label}
      placeholder={placeholder}
      {...rest}
    />
  );
};
